/**
 * E2E mock authentication: when localStorage has e2e_mock_role set by Playwright,
 * the app treats the user as logged in with that role and sends mock headers to the API.
 * Backend must have ALLOW_MOCK_AUTH=true and MOCK_AUTH_SECRET matching VITE_E2E_MOCK_SECRET.
 */

export type E2EMockRole = 'user' | 'consultant' | 'admin';

const E2E_ROLE_KEY = 'e2e_mock_role';
const VALID_ROLES: E2EMockRole[] = ['user', 'consultant', 'admin'];

export function getE2EMockRole(): E2EMockRole | null {
  if (typeof window === 'undefined') return null;
  const value = localStorage.getItem(E2E_ROLE_KEY);
  if (value && VALID_ROLES.includes(value as E2EMockRole)) return value as E2EMockRole;
  return null;
}

export function isE2EMockAuth(): boolean {
  return getE2EMockRole() !== null;
}

export function getE2EMockSecret(): string {
  return (import.meta.env.VITE_E2E_MOCK_SECRET as string) || '';
}
